import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, withAllColumnsWidth, withColumnsWithValuesWidth } from '../../utils';
import { getHeaders } from './headers';
import { getColumnsWidths } from './styles';
import { CashOnCashExport } from 'src/app/domain/cashflow/dto/CashOnCashExport';
import { getPreparedData } from './mappingCashFLow';
import { CashFlowMiniDTO } from 'src/app/domain/cashflow/dto/CashFlowMiniDTO';

export class CashFlowDealFlowTemplate implements ExcelTemplate {

  export(exportExcelData: CashOnCashExport): XLSX.WorkBook {
    const companies = exportExcelData.mainData;
    const book = XLSX.utils.book_new();
    const firstCompanyCashFlowList = companies[0]?.cashFlowList;
    if (firstCompanyCashFlowList?.length > 0) {
      const sheet = this.getSheet(exportExcelData, firstCompanyCashFlowList);
      XLSX.utils.book_append_sheet(book, sheet);
      return book;
    }
  }


  private getSheet(exportExcelData: CashOnCashExport, cashFlowList: CashFlowMiniDTO[]): XLSX.WorkSheet {
    const headers = getHeaders(cashFlowList, exportExcelData);
    const preparedData = getPreparedData(exportExcelData, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    return withColumnsWithValuesWidth(withAllColumnsWidth(withHeaderStyling(sheet)),
      getColumnsWidths(exportExcelData.selectedPeriod));
  }
}
